<template>
    <v-dialog v-model="dialogShow" persistent width="800" >
        <div style="background: white;width: 100%;height: 650px">
            <!--标题-->
            <div style="height: 70px;width: 100%;border-bottom:1px solid #a6a6a6;">
                <v-layout class="ma-0" fill-height justify-space-between align-center>
                    <div style="font-size: 20px;line-height: 28px;color: black;margin-left: 22px">团队文件</div>
                    <div @click="closeDialog" style="font-size: 15px;color: #a6a6a6;margin-right: 27px;cursor: pointer" class="iconfontFamily"> &#xe60d;</div>
                </v-layout>
            </div>
            <!--tab选项卡-->
            <div style="height: 53px;display: flex;align-items: end;padding-left: 62px;">
                <div style="width: 54px;height: 30px;cursor: pointer" @click="operationSelect = 'Collaborator'">
                    <v-layout column fill-height align-center class="ma-0">
                        <div :style="{'color':operationSelect === 'Collaborator' ? '#000000':'#a6a6a6'}" style="height: 25px; width: 54px;line-height: 25px;font-size: 18px;text-align: center">协作者</div>
                        <div v-if="operationSelect === 'Collaborator'" style="width: 32px;height: 5px;border-radius: 5px;background: rgba(32, 81, 138, 1);"></div>
                        <div v-else style="width: 32px;height: 5px;"></div>
                    </v-layout>
                </div >
                <div style="width: 36px;height: 30px;margin-left: 24px;cursor: pointer" @click="operationSelect = 'Setting'">
                    <v-layout column fill-height align-center class="ma-0">
                        <div :style="{'color':operationSelect === 'Setting' ? '#000000':'#a6a6a6'}"  style="height: 25px; width: 54px;line-height: 25px;font-size: 18px;text-align: center">设置</div>
                        <div v-if="operationSelect === 'Setting'" style="width: 32px;height: 5px;border-radius: 5px;background: rgba(32, 81, 138, 1);"></div>
                        <div v-else style="width: 32px;height: 5px;"></div>
                    </v-layout>
                </div>
            </div>

            <!--内容区   style="padding: 26px 62px 0 62px;"-->
            <div style="width: 100%;overflow: hidden">
                <!--协作者界面-->
                <div v-if="operationSelect === 'Collaborator'" >
                    <div style="width: 676px;font-size: 14px;color: rgba(128, 128, 128, 1);margin: 26px 62px 0 62px;">
                        <v-layout class="ma-0" justify-space-between>
                            <div style="margin-left: 78px">协作者</div>
                            <div style="margin-right: 90px">角色</div>
                        </v-layout>
                    </div>
                    <div style="width: 676px;height: 1px;background: rgba(229, 229, 229, 1);margin: 6px 62px 0 62px;"></div>
                    <div style="width: 100%;height: 391px;overflow-y: auto;overflow-x: hidden;padding: 10px 112px">
                        <template v-for="(item, index) in memberList">
                            <div style="height: 52px;margin-top: 10px;margin-bottom: 10px;" :key="index">
                                <v-layout class="ma-0" fill-height align-center justify-space-between>
                                    <div>
                                        <v-layout class="ma-0" fill-height align-center >
                                            <v-avatar size="45">
                                                <v-img :src="item.avatar"></v-img>
                                            </v-avatar>
                                            <div  v-if="nickNameIndex !==index" style="margin-left: 10px;line-height: 22px">{{item.nickName}}</div>
                                            <div v-if="item.userId === $store.state.userId && !isEditNick" style="color: rgba(166, 166, 166, 1);line-height: 22px">[我]</div>
                                            <div v-if="item.userId === $store.state.userId">
                                                <div v-if="!isEditNick" @click="editNickName(item.nickName,index)" style="color: rgba(25, 110, 207, 1);margin-left: 15px;cursor: pointer">修改昵称</div>
                                                <div v-else style="width: 240px;margin-left: 10px">
                                                    <v-text-field
                                                            v-model="nickNameText"
                                                            dense
                                                            counter="10"
                                                            style="margin-top: 16px"
                                                    >
                                                        <template v-slot:append>
                                                            <div @click=" nickNameText.length <=10 ? saveNickName():''" style="cursor: pointer;margin-top: 6px;width: 32px;" :style="{'color':nickNameText.length <=10 ? 'rgba(25, 118, 210, 1)':'rgba(128, 128, 128, 1)'}">保存</div>
                                                        </template>
                                                    </v-text-field>
                                                </div>
                                            </div>
                                        </v-layout>
                                    </div>
                                    <div>
                                        <v-layout class="ma-0" fill-height align-center >
                                            <div>{{roleToName(item.role)}}</div>
                                            <v-menu

                                                    bottom
                                                    offset-y
                                                    nudge-left="70"
                                                    nudge-bottom="8"
                                                    v-if="item.role > myRole || item.userId === $store.state.userId"

                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <div v-on="on"  v-bind="attrs" class="iconfontFamily" style="cursor: pointer;color: rgba(166, 166, 166, 1);font-size: 16px;margin-left: 12px">&#xe685;</div>
                                                </template>
                                                <v-card style="width: 100px;height: 92px" v-if="myRole === 1&&item.role ===1">
                                                    <v-layout class="ma-0" column align-center>
                                                        <v-hover v-slot="{ hover }" >
                                                            <div style="width: 100%;height: 30px;margin-top: 8px;cursor: pointer" :style="{'background': hover? 'rgba(25, 110, 207, 0.25)':'white'}" >
                                                                <v-layout class="ma-0" align-center justify-center>
                                                                    <div class="iconfontFamily" style="font-size: 16px;color: rgba(25, 110, 207, 1)">&#xe687;</div>
                                                                    <div style="line-height: 30px;margin-left: 10px">创建者</div>
                                                                </v-layout>
                                                            </div>
                                                        </v-hover>
                                                        <div style="height: 1px;width: 62px;background: rgba(229, 229, 229, 1);margin-top: 8px"></div>
                                                        <v-hover v-slot="{ hover }" >
                                                            <div style="width: 100%;height: 30px;color: red;margin-top: 8px;cursor: pointer;line-height: 30px;text-align: center" :style="{'background': hover? 'rgba(25, 110, 207, 0.25)':'white'}" @click="dissolveTeam">解散团队</div>
                                                        </v-hover>

                                                    </v-layout>
                                                </v-card>
                                                <v-card style="width: 100px;height: 160px" v-if="myRole === 1&&(item.role ===2|| item.role ===3)">
                                                    <v-layout class="ma-0" column align-center>
                                                        <div v-if="item.role ===2" style="width: 100%">
                                                            <v-hover v-slot="{ hover }" >
                                                                <div style="width: 100%;height: 30px;margin-top: 8px;cursor: pointer" :style="{'background': hover? 'rgba(25, 110, 207, 0.25)':'white'}">
                                                                    <v-layout class="ma-0" align-center justify-center>
                                                                        <div class="iconfontFamily" style="font-size: 16px;color: rgba(25, 110, 207, 1)">&#xe687;</div>
                                                                        <div style="line-height: 30px;margin-left: 10px">管理者</div>
                                                                    </v-layout>
                                                                </div>
                                                            </v-hover>
                                                            <v-hover v-slot="{ hover }">
                                                                <div @click="changeRole(item.userId,3)" style="width: 100%;height: 30px;margin-top: 8px;cursor: pointer;" :style="{'background': hover? 'rgba(25, 110, 207, 0.25)':'white'}">
                                                                    <v-layout class="ma-0" align-center justify-center>
                                                                        <div style="font-size: 16px;width: 16px;height: 16px"></div>
                                                                        <div style="line-height: 30px;margin-left: 10px">编辑者</div>
                                                                    </v-layout>
                                                                </div>
                                                            </v-hover>
                                                        </div>
                                                        <div v-if="item.role ===3" style="width: 100%">
                                                            <v-hover v-slot="{ hover }" >
                                                                <div @click="changeRole(item.userId,2)" style="width: 100%;height: 30px;margin-top: 8px;cursor: pointer" :style="{'background': hover? 'rgba(25, 110, 207, 0.25)':'white'}">
                                                                    <v-layout class="ma-0" align-center justify-center>
                                                                        <div style="font-size: 16px;width: 16px;height: 16px"></div>
                                                                        <div style="line-height: 30px;margin-left: 10px">管理者</div>
                                                                    </v-layout>
                                                                </div>
                                                            </v-hover>
                                                            <v-hover v-slot="{ hover }" >
                                                                <div style="width: 100%;height: 30px;margin-top: 8px;cursor: pointer" :style="{'background': hover? 'rgba(25, 110, 207, 0.25)':'white'}">
                                                                    <v-layout class="ma-0" align-center justify-center>
                                                                        <div class="iconfontFamily" style="font-size: 16px;color: rgba(25, 110, 207, 1)">&#xe687;</div>
                                                                        <div style="line-height: 30px;margin-left: 10px">编辑者</div>
                                                                    </v-layout>
                                                                </div>
                                                            </v-hover>
                                                        </div>
                                                        <div style="height: 1px;width: 62px;background: rgba(229, 229, 229, 1);margin-top: 6px"></div>
                                                        <v-hover v-slot="{ hover }" >
                                                            <div style="width: 100%;height: 30px;margin-top: 6px;cursor: pointer;text-align: center;line-height: 30px" :style="{'background': hover? 'rgba(25, 110, 207, 0.25)':'white'}" @click="handoverTeam(item.userId)">移交团队</div>
                                                        </v-hover>
                                                        <v-hover v-slot="{ hover }" >
                                                            <div style="width: 100%;height: 30px;color: red;margin-top: 8px;cursor: pointer;text-align: center;line-height: 30px" :style="{'background': hover? 'rgba(25, 110, 207, 0.25)':'white'}" @click="removeMember(item.userId)">移除协作者</div>
                                                        </v-hover>
                                                    </v-layout>
                                                </v-card>
                                                <v-card style="width: 100px;height: 92px" v-if="myRole === 2&&item.role ===2">
                                                    <v-layout class="ma-0" column align-center>
                                                        <v-hover v-slot="{ hover }">
                                                            <div style="width: 100%;height: 30px;margin-top: 8px;cursor: pointer" :style="{'background': hover? 'rgba(25, 110, 207, 0.25)':'white'}">
                                                                <v-layout class="ma-0" align-center justify-center>
                                                                    <div class="iconfontFamily" style="font-size: 16px;color: rgba(25, 110, 207, 1)">&#xe687;</div>
                                                                    <div style="line-height: 30px;margin-left: 10px">管理者</div>
                                                                </v-layout>
                                                            </div>
                                                        </v-hover>
                                                        <div style="height: 1px;width: 62px;background: rgba(229, 229, 229, 1);margin-top: 8px"></div>
                                                        <v-hover v-slot="{ hover }">
                                                            <div style="width: 100%;height: 30px;color: red;margin-top: 8px;cursor: pointer;text-align: center;line-height: 30px" :style="{'background': hover? 'rgba(25, 110, 207, 0.25)':'white'}" @click="exitTeam(item.userId)">退出协作</div>
                                                        </v-hover>
                                                    </v-layout>
                                                </v-card>
                                                <v-card style="width: 100px;height: 126px" v-if="myRole === 2&&item.role ===3">
                                                    <v-layout class="ma-0" column align-center>
                                                        <v-hover v-slot="{ hover }" >
                                                            <div @click="changeRole(item.userId,2)" style="width: 100%;height: 30px;margin-top: 8px;cursor: pointer" :style="{'background': hover? 'rgba(25, 110, 207, 0.25)':'white'}">
                                                                <v-layout class="ma-0" align-center justify-center>
                                                                    <div style="font-size: 16px;width: 16px;height: 16px"></div>
                                                                    <div style="line-height: 30px;margin-left: 10px">管理者</div>
                                                                </v-layout>
                                                            </div>
                                                        </v-hover>
                                                        <v-hover v-slot="{ hover }" >
                                                            <div style="width: 100%;height: 30px;margin-top: 8px;cursor: pointer" :style="{'background': hover? 'rgba(25, 110, 207, 0.25)':'white'}">
                                                                <v-layout class="ma-0" align-center justify-center>
                                                                    <div class="iconfontFamily" style="font-size: 16px;color: rgba(25, 110, 207, 1)">&#xe687;</div>
                                                                    <div style="line-height: 30px;margin-left: 10px">编辑者</div>
                                                                </v-layout>
                                                            </div>
                                                        </v-hover>
                                                        <div style="height: 1px;width: 62px;background: rgba(229, 229, 229, 1);margin-top: 6px"></div>
                                                        <v-hover v-slot="{ hover }" >
                                                            <div  style="width: 100%;height: 30px;color: red;margin-top: 6px;cursor: pointer;text-align: center;line-height: 30px" :style="{'background': hover? 'rgba(25, 110, 207, 0.25)':'white'}" @click="removeMember(item.userId)">移除协作者 </div>
                                                        </v-hover>
                                                    </v-layout>
                                                </v-card>
                                                <v-card style="width: 100px;height: 92px" v-if="myRole === 3&&item.role ===3">
                                                    <v-layout class="ma-0" column align-center>
                                                        <v-hover v-slot="{ hover }">
                                                            <div style="width: 100%;height: 30px;margin-top: 8px;cursor: pointer" :style="{'background': hover? 'rgba(25, 110, 207, 0.25)':'white'}">
                                                                <v-layout class="ma-0" align-center justify-center>
                                                                    <div class="iconfontFamily" style="font-size: 16px;color: rgba(25, 110, 207, 1)">&#xe687;</div>
                                                                    <div style="line-height: 30px;margin-left: 10px">编辑者</div>
                                                                </v-layout>
                                                            </div>
                                                        </v-hover>
                                                        <div style="height: 1px;width: 62px;background: rgba(229, 229, 229, 1);margin-top: 8px"></div>
                                                        <v-hover v-slot="{ hover }">
                                                            <div :style="{'background': hover? 'rgba(25, 110, 207, 0.25)':'white'}" style="width: 100%;height: 30px;color: red;margin-top: 8px;cursor: pointer;text-align: center;line-height: 30px" @click="exitTeam(item.userId)">退出协作</div>
                                                        </v-hover>
                                                    </v-layout>
                                                </v-card>
                                            </v-menu>
                                            <div v-else style="width: 16px;height: 16px;margin-left: 12px"></div>
                                        </v-layout>
                                    </div>

                                </v-layout>
                            </div>
                        </template>
                    </div>
                    <!--按钮区-->
                    <div style="height: 80px;width: 100%;">
                        <v-layout class="ma-0" justify-center align-center fill-height>
                            <div style="width: 200px;height: 35px;background: rgba(42, 130, 228, 1);cursor: pointer" @click="inviteCollaborators">
                                <v-layout class="ma-0" justify-center align-center fill-height>
                                    <div class="iconfontFamily" style="font-size: 16px;color: white">&#xe688;</div>
                                    <div style="margin-left: 12px;color: white">邀请协作者</div>
                                </v-layout>
                            </div>
                        </v-layout>
                    </div>
                </div>
                <!--文件设置-->
                <div v-else style="padding: 32px 62px 0 62px">
                    <div style="display: flex;width: 100%;">
                        <div style="font-size: 18px;color: black;line-height: 26px">团队文件名称：</div>
                        <div style="margin-left: 15px;width: 400px;height: 26px">
                            <v-text-field
                                    v-model="teamFolderName"
                                    :readonly="nameEditBtn === '修改'"
                                    dense
                                    class="ma-0"
                                    counter="30"
                                    :rules="rules"
                            >
                                <template v-slot:append>
                                    <div @click=" teamFolderName.length > 30 ? '':editFolderName()" style="cursor: pointer;margin-top: 4px" :style="{'color':teamFolderName.length > 30 ?'rgba(166, 166, 166, 1)':'rgba(25, 118, 210, 1)'}">{{nameEditBtn}}</div>
                                </template>
                            </v-text-field>
                        </div>
                    </div>

                    <div style="width: 676px;height: 1px;background: rgba(229, 229, 229, 1);margin-top: 35px"></div>
                    <div style="align-items:center;">
                        <div style="margin-left: 16px;display: flex;margin-top: 10px">
                            <div style="width: 200px;">
                                <v-radio-group
                                        v-model="teamFileSelect"
                                        column
                                        @change="changeReadonly"
                                        :disabled="isDisabled"
                                >
                                    <v-radio
                                            color="rgba(42, 130, 228, 1)"
                                            :value="0"
                                    >
                                        <template v-slot:label>
                                            <div :style="{'color':teamFileSelect === 0 ? '#000000':'#a6a6a6'}" style="margin-left: 5px">团队文件中数据可新增</div>
                                        </template>
                                    </v-radio>
                                    <v-radio
                                            color="rgba(42, 130, 228, 1)"
                                            :value="1"
                                            style="margin-top: 11px"
                                    >
                                        <template v-slot:label>
                                            <div style="display: flex;align-items: center">
                                                <div :style="{'color':teamFileSelect === 1 ? '#000000':'#a6a6a6'}" style="margin-left: 5px">团队文件只读</div>
                                            </div>
                                        </template>
                                    </v-radio>
                                </v-radio-group>
                            </div>
                            <div style="margin-top: 20px;margin-left: 60px;font-size: 14px">
                                <div :style="{'color':teamFileSelect === 0 ? '#000000':'#a6a6a6'}" style="margin-bottom: 18px;line-height: 24px">可新增数据，同时可编辑、删除本人创建的数据</div>
                                <div :style="{'color':teamFileSelect === 1 ? '#000000':'#a6a6a6'}" style="line-height: 24px">团队文件中所有的数据都不能由协作者进行编辑</div>
                            </div>
                        </div>
                        <div style="width: 586px;height: 1px;background: rgba(229, 229, 229, 1);margin-top: 4px"></div>
                        <div style="margin-left: 16px;display: flex;margin-top: 28px;">
                            <v-checkbox
                                    v-model="allowMembersExportFiles"
                                    color="#297aff"
                                    hide-details
                                    dense
                                    :disabled="isDisabled"
                                    class="ma-0"
                                    @change="changeExport"
                            >
                                <template v-slot:label>
                                    <div style="color: black;margin-left: 5px">允许团队文件协作者导出团队文件</div>
                                </template>
                            </v-checkbox>
                            <div style="width: 60px"></div>
                        </div>
                        <div style="width: 586px;height: 1px;background: rgba(229, 229, 229, 1);margin-top: 28px"></div>
                        <div style="margin-left: 16px;display: flex;margin-top: 28px;">
                            <v-checkbox
                                    v-model="allowMembersSaveFiles"
                                    color="#297aff"
                                    hide-details
                                    dense
                                    :disabled="isDisabled"
                                    class="ma-0"
                                    @change="changeSave"
                            >
                                <template v-slot:label>
                                    <div style="color: black;margin-left: 5px">允许团队文件协作者保存团队数据文件</div>
                                </template>
                            </v-checkbox>
                            <div style="width: 60px"></div>
                        </div>
                        <div style="width: 586px;height: 1px;background: rgba(229, 229, 229, 1);margin-top: 28px"></div>
                        <div style="margin-left: 16px;display: flex;margin-top: 28px;">
                            <v-checkbox
                                    v-model="allowMembersInviteOthers"
                                    color="#297aff"
                                    hide-details
                                    dense
                                    :disabled="isDisabled"
                                    class="ma-0"
                                    @change="changeInvite"
                            >
                                <template v-slot:label>
                                    <div style="color: black;margin-left: 5px">允许团队文件协作者邀请其他协作者</div>
                                </template>
                            </v-checkbox>
                            <div style="width: 60px"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <v-dialog v-if="inviteCollaboratorsDialogShow" v-model="inviteCollaboratorsDialogShow" persistent width="800" content-class="preDialog">
            <div style="width: 100%;height: 100%">
                <div style="background: white;margin-top: 106px">
                    <div style="height: 70px;width: 100%;border-bottom:1px solid #a6a6a6;">
                        <v-layout class="ma-0" fill-height justify-space-between align-center>
                            <div style="font-size: 20px;line-height: 28px;color: black;margin-left: 22px">团队文件</div>
                            <div @click="closeInviteDialog" style="font-size: 15px;color: #a6a6a6;margin-right: 27px" class="iconfontFamily"> &#xe60d;</div>
                        </v-layout>
                    </div>
                    <!--内容-->
                    <div style="height: 230px;width: 100%;padding: 40px 53px 24px 53px;">
                        <div>分享邀请链接，点击加入团队协作</div>
                        <div style="width: 100%;height: 40px;margin-top: 40px">
                            <v-layout class="ma-0" fill-height justify-space-between align-center>
                                <div style="width: 524px;height: 40px">
                                    <v-text-field
                                            v-model="inviteLink"
                                            height="40"
                                            outlined
                                            dense
                                            readonly
                                    ></v-text-field>
                                </div>
                                <div style="width: 146px;height: 40px;border-radius: 4px;background: rgba(42, 130, 228, 1);cursor: pointer" @click="doCopy()">
                                    <v-layout class="ma-0" fill-height justify-center align-center>
                                        <div class="iconfontFamily" style="color: white">&#xe68a;</div>
                                        <div style="margin-left: 8px;color: white">复制邀请链接</div>
                                    </v-layout>
                                </div>
                            </v-layout>
                        </div>

                        <div style="border: 1px solid rgba(229, 229, 229, 1);width: 40px;height: 40px;border-radius: 50%;align-items: center;text-align: center;margin-top: 40px;cursor: pointer" @click="openQRCode">
                            <div class="iconfontFamily" style="font-size: 24px;color: black">&#xe689;</div>
                        </div>
                    </div>
                </div>

                <div style="width: 180px;height: 212px;background: white;margin-top: 8px" v-show="qrCodeShow">
                    <v-layout column class="ma-0" align-center>
                        <div style="margin-top: 15px">共生地球APP扫码加入</div>
                        <div ref="inviteQrCode" style="width: 140px;height: 140px;margin-top: 15px"></div>
                    </v-layout>
                </div>
                <div v-show="!qrCodeShow" style="width: 180px;height: 212px;margin-top: 8px"></div>
            </div>
        </v-dialog>
        <v-dialog v-model="tipsDialogShow" persistent width="520">
            <v-card>
                <div style="height:68px;border-bottom:1px solid #a6a6a6;padding:0 25px 0 22px !important;display: flex;align-items: center">
                    <div style=" font-size:20px;color:#000000;">提示</div>
                    <v-spacer></v-spacer>
                    <div @click="closeTipsDialog" class="iconfontFamily" style="font-size:15px;color:#A6A6A6;cursor:pointer;">&#xe60d;</div>
                </div>
                <div style="padding-bottom: 16px">
                    <div v-if="tipsType === '移交'" style="width: 100%;padding: 50px 24px 56px 24px;color: black;font-size: 16px">
                        <div style="line-height: 22px">将团队创建者身份移交给此协作者，您的角色将变为管理者。</div>
                        <div style="line-height: 22px;margin-top: 16px">确定要移交团队吗？</div>
                    </div>
                    <div v-if="tipsType === '退出'" style="width: 100%;padding: 50px 24px 56px 24px;color: black;font-size: 16px">
                        <div style="line-height: 22px">退出协作后，将无法访问团队文件中的任何资源，无法继续参与协作。</div>
                        <div style="line-height: 22px;margin-top: 16px">确定要退出团队协作吗？</div>
                    </div>
                    <div v-if="tipsType === '移除'" style="width: 100%;padding: 50px 24px 56px 24px;color: black;font-size: 16px">
                        <div style="line-height: 22px">移除协作者后，此协作者将无法访问团队文件中的任何资源，无法继续参与协作。</div>
                        <div style="line-height: 22px;margin-top: 16px">确定要移除协作者吗？</div>
                    </div>
                    <div v-if="tipsType === '解散'" style="width: 100%;padding: 50px 24px 56px 24px;color: black;font-size: 16px">
                        <div style="line-height: 22px">解散团队后，团队文件将永久删除，所有协作者将无法访问此团队文件。</div>
                        <div style="line-height: 22px;margin-top: 16px">您可以在团队文件协作者列表移交团队至指定协作者。</div>
                        <div style="line-height: 22px;margin-top: 16px">确定要解散团队吗？</div>
                    </div>
                    <div style="height: 35px;width: 100%;">
                        <div class="float-right" style="width: 100px;height: 35px;line-height: 35px;text-align: center;cursor: pointer;margin-right: 27px;background: rgba(245, 245, 245, 1)" @click="closeTipsDialog ">取消</div>
                        <div class="float-right" style="width: 100px;height: 35px;line-height: 35px;text-align: center;cursor: pointer;color: white;margin-right: 24px;background: rgba(30, 58, 138, 1)" @click="confirmTips">确定</div>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>

<script>
    import QRCode from 'qrcodejs2'
    export default {
        name: "MemberListDialog",
        props:["dialogShow"],
        data(){
            return{
                rules: [v => v.length <= 30],
                operationSelect:'Collaborator',
                inviteCollaboratorsDialogShow:false,
                inviteLink:'',
                qrCodeShow:false,
                teamFolderName:this.$store.state.currFolderName,
                nameEditBtn:'修改',
                folderTypeSelect:'0',
                teamFileSelect:this.$store.state.currFolderTeamReadonly ,
                allowMembersExportFiles:this.$store.state.currFolderTeamExport ===1,
                allowMembersSaveFiles:this.$store.state.currFolderTeamSave ===1,
                allowMembersInviteOthers:this.$store.state.currFolderTeamInvite ===1,
                isDisabled:true,//是否可以编辑权限
                isEditNick:false,//是否编辑昵称
                nickNameText:'',//
                nickNameIndex:-1,
                tipsDialogShow:false,
                tipsType:'',
                tempId:'',//中间变量
                myRole:1,
                //样例数据
                memberList:[
                    {
                        "avatar": "https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202210140930000013123.png",
                        "gmtCreatetime": "2023-10-14 14:36:00",
                        "id": 1,
                        "nickName": "创作者527924",
                        "role": 2,
                        "teamId": "5cb7030666114d35a623e3d0da9355a2",
                        "userId": "1665710916376171"
                    },
                ]
            }
        },
        methods:{
            //获取列表
            getMemberList(){
                this.memberList = []
                this.$axios.get('/authorApi/z-geo-team/getTeamMembers', {
                    params: {
                        'teamId': this.$store.state.currFolderId,
                    }
                }).then((res)=>{
                    if(res.data.status === 200){
                        this.memberList = res.data.data.teamList
                        this.isDisabled = !(res.data.data.myRole === 1)
                        this.myRole = res.data.data.myRole
                        this.$store.state.currFolderMembersNumber = res.data.data.teamList.length
                        this.$store.state.currFolderRole = res.data.data.myRole
                    }else{
                        this.$store.state.snackbarShow=true
                        this.$store.state.snackbarText = "获取成员列表失败，请关闭重试"
                        this.$store.state.snackbarType = 'error'
                    }
                }).catch((err)=>{
                    this.$store.state.snackbarShow=true
                    this.$store.state.snackbarText = err
                    this.$store.state.snackbarType = 'error'
                })
            },
            closeDialog(){
                this.$emit("closeDialog")
            },
            //邀请协作者 调用接口
            inviteCollaborators(){

                this.$axios.get('/authorApi/z-geo-team/inviteIntoTeam',{
                    params:{
                        teamId:this.$store.state.currFolderId
                    }
                }).then((res)=>{
                    if(res.data.status === 200){
                        this.inviteCollaboratorsDialogShow = true
                        this.inviteLink = res.data.data.shareFileUrl
                        // this.$refs.inviteQrCode.innerHTML = '';
                        //获取邀请码
                        let temp = res.data.data.shareFileQrCode
                        setTimeout(()=>{
                            new QRCode(this.$refs.inviteQrCode, {
                                //二维码内容
                                text: temp,
                                width: 140,
                                height: 140,
                                colorDark: '#000000',
                                colorLight: '#ffffff',
                                correctLevel: QRCode.CorrectLevel.H,
                            });
                        },1000)

                    }else if(res.data.status === 5604){
                        this.$store.state.snackbarShow=true
                        this.$store.state.snackbarText = "协作者数量已达上限！"
                        this.$store.state.snackbarType = 'error'
                    }else{
                        this.$store.state.snackbarShow=true
                        this.$store.state.snackbarText = res.data.message
                        this.$store.state.snackbarType = 'error'
                    }
                }).catch(()=>{
                    this.$store.state.snackbarShow=true
                    this.$store.state.snackbarText = "邀请失败"
                    this.$store.state.snackbarType = 'error'
                })
            },
            openQRCode(){
                this.qrCodeShow = true
            },
            closeInviteDialog(){
                this.inviteCollaboratorsDialogShow = false
                this.qrCodeShow = false
            },
            handleOnMouseDown(){
                this.qrCodeShow = false
            },
            doCopy(){
                let context = JSON.parse(JSON.stringify(this.inviteLink))
                if(window.clipboardData){
                    window.clipboardData.setData('text',context)
                    this.$store.state.snackbarShow=true
                    this.$store.state.snackbarText = "邀请链接复制成功"
                    this.$store.state.snackbarType = 'success'
                }else if(document.execCommand('Copy')){
                    (function () {
                        document.oncopy = function (e) {
                            e.clipboardData.setData('text',context)
                            e.preventDefault()
                            document.oncopy = null
                        }
                    })(context)
                    document.execCommand('Copy')
                    this.$store.state.snackbarShow=true
                    this.$store.state.snackbarText = "邀请链接复制成功"
                    this.$store.state.snackbarType = 'success'
                }else{
                        this.$store.state.snackbarShow=true
                        this.$store.state.snackbarText = "邀请链接复制失败"
                        this.$store.state.snackbarType = 'error'
                }
                // let _this = this
                //
                // console.log(context)
                // this.$copyText(context).then(function () {
                //     _this.$store.state.snackbarShow=true
                //     _this.$store.state.snackbarText = "邀请链接复制成功"
                //     _this.$store.state.snackbarType = 'success'
                // },function () {
                //     _this.$store.state.snackbarShow=true
                //     _this.$store.state.snackbarText = "邀请链接复制失败"
                //     _this.$store.state.snackbarType = 'error'
                // })
            },
            //修改团队名称
            editFolderName(){
                if(this.nameEditBtn ==='修改')
                    this.nameEditBtn = '保存'
                else{
                    //修改外层的名字-调用接口
                    this.editFolderNameNet()
                }
            },
            editFolderNameNet(){
                 if(this.teamFolderName.length === 0){
                     this.$store.state.snackbarShow=true
                     this.$store.state.snackbarText = "团队文件名称不能为空"
                     this.$store.state.snackbarType = 'error'
                 }else{
                     let data = new FormData()
                     data.append('fileName',this.teamFolderName)
                     data.append('fileId',this.$store.state.currFolderId)
                     this.$axios.post('/authorApi/z-geo-file/rename',data).then((res)=>{
                         if(res.data.status === 200){
                             this.nameEditBtn = '修改'
                             this.$store.state.currFolderName = this.teamFolderName
                             this.$store.state.snackbarShow=true
                             this.$store.state.snackbarText = "团队文件名称修改成功"
                             this.$store.state.snackbarType = 'success'
                             this.$emit('teamFileRenameOk')
                         }else if(res.data.status === 308){
                             this.$store.state.snackbarShow=true
                             this.$store.state.snackbarText = "团队文件名称不能重复"
                             this.$store.state.snackbarType = 'error'
                         }else{
                             this.$store.state.snackbarShow=true
                             this.$store.state.snackbarText = "团队文件名称修改失败"
                             this.$store.state.snackbarType = 'error'
                         }
                     })
                 }
            },
            //修改个人昵称
            editNickName(val,index){
                this.nickNameText = val
                this.isEditNick = true
                this.nickNameIndex = index
            },
            saveNickName(){
                if(this.nickNameText.length ===0){
                    this.$store.state.snackbarShow=true
                    this.$store.state.snackbarText = "昵称不能为空"
                    this.$store.state.snackbarType = 'error'
                }else if(this.nickNameText.length >10){
                    // this.$store.state.snackbarShow=true
                    // this.$store.state.snackbarText = "昵称最长10个字符"
                    // this.$store.state.snackbarType = 'error'
                }else{
                    let data = new FormData()
                    data.append('newName',this.nickNameText)
                    data.append('teamId',this.$store.state.currFolderId)
                    this.$axios.post('/authorApi/z-geo-team/renameSelfInTeam',data)
                        .then((res)=>{
                            if(res.data.status === 200){
                                // this.memberList[0].nickName = this.nickNameText
                                this.nickNameText = ''
                                this.isEditNick = false
                                this.nickNameIndex = -1
                                this.getMemberList()
                                this.$store.state.snackbarShow=true
                                this.$store.state.snackbarText = "昵称修改成功"
                                this.$store.state.snackbarType = 'success'
                                this.$emit('reNameOk')
                            }else{
                                this.$store.state.snackbarShow=true
                                this.$store.state.snackbarText = "昵称修改失败"
                                this.$store.state.snackbarType = 'error'
                            }
                        }).catch(()=>{
                        this.$store.state.snackbarShow=true
                        this.$store.state.snackbarText = "昵称修改失败"
                        this.$store.state.snackbarType = 'error'
                    })
                }

            },
            roleToName(val){
                const map={
                    1:'创建者',
                    2:'管理者',
                    3:'编辑者',
                }
                return map[val]
            },
            //解散团队
            dissolveTeam(){
                this.tipsType = '解散'
                this.tipsDialogShow = true
            },
            dissolveTeamNet(){
                let data= new FormData()
                data.append('teamId',this.$store.state.currFolderId)
                this.$axios.post('/authorApi/z-geo-team/dissolveTeam',data)
                    .then((res)=>{
                        //提示弹窗关闭
                        this.tipsDialogShow = false
                        this.tipsType = ''
                        this.tempId = ''
                        if(res.data.status === 200){

                            //
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "解散团队成功"
                            this.$store.state.snackbarType = 'success'
                            //关闭弹窗，打开新的团队文件
                            this.$emit("dissolveTeamOk",res.data.data)
                        }else{
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "解散团队失败"
                            this.$store.state.snackbarType = 'error'
                        }
                    })
            },
            //修改团队成员角色
            changeRole(val ,role) {
                let data = new FormData()
                data.append('teamId',this.$store.state.currFolderId)//ID
                data.append('editedUserId',val)
                data.append('newRole',role)
                this.$axios.post('/authorApi/z-geo-team/editTeamUserRole',data)
                    .then((res)=>{
                        if(res.data.status === 200){
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "协作者角色修改成功"
                            this.$store.state.snackbarType = 'success'
                            //重新拉取接口刷新页面
                            this.getMemberList()
                        }else{
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "协作者角色修改失败"
                            this.$store.state.snackbarType = 'error'
                            //重新拉取接口刷新页面
                            this.getMemberList()
                        }
                    }).catch(()=>{
                    this.$store.state.snackbarShow=true
                    this.$store.state.snackbarText = "协作者角色修改失败"
                    this.$store.state.snackbarType = 'error'
                })

            },
            //移交
            handoverTeam(val){
                this.tempId = val
                this.tipsType = '移交'
                this.tipsDialogShow = true
            },
            handoverTeamNet(){
                let data= new FormData()
                data.append('teamId',this.$store.state.currFolderId)
                data.append('newCreatorUserId',this.tempId)
                this.$axios.post('/authorApi/z-geo-team/transferTeam',data)
                    .then((res)=>{
                        this.tipsDialogShow = false
                        this.tipsType = ''
                        this.tempId = ''

                        if(res.data.status === 200){
                            this.$store.state.currFolderRole = 2
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "移交团队成功 "
                            this.$store.state.snackbarType = 'success'
                            //刷新列表
                            this.getMemberList()
                        }else{
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "移交团队失败"
                            this.$store.state.snackbarType = 'error'
                            //刷新列表
                            this.getMemberList()
                        }
                    }).catch(()=>{
                    this.$store.state.snackbarShow=true
                    this.$store.state.snackbarText = "移交团队失败 "
                    this.$store.state.snackbarType = 'error'
                })
            },
            //移除成员
            removeMember(val){
                this.tempId = val
                this.tipsType = '移除'
                this.tipsDialogShow = true
            },
            removeMemberNet(){
                let data= new FormData()
                data.append('teamId',this.$store.state.currFolderId)
                data.append('removedUserId',this.tempId)
                this.$axios.post('/authorApi/z-geo-team/removeFromTeam',data)
                    .then((res)=>{
                        this.tipsDialogShow = false
                        this.tipsType = ''
                        this.tempId = ''
                        if(res.data.status === 200){
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "移除协作者成功"
                            this.$store.state.snackbarType = 'success'
                            //团队成员数减1
                            this.$store.state.currFolderMembersNumber = this.$store.state.currFolderMembersNumber-1
                            this.getMemberList()
                        }else{
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "移除协作者失败"
                            this.$store.state.snackbarType = 'error'
                        }
                    })
            },
            exitTeam(val){
                this.tempId = val
                this.tipsType = '退出'
                this.tipsDialogShow = true
            },
            exitTeamNet(){
                let data= new FormData()
                data.append('teamId',this.$store.state.currFolderId)
                this.$axios.post('/authorApi/z-geo-team/exitTeam',data)
                    .then((res)=>{
                        //提示弹窗关闭
                        this.tipsDialogShow = false
                        this.tipsType = ''
                        this.tempId = ''
                        if(res.data.status === 200){
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "退出协作成功 "
                            this.$store.state.snackbarType = 'success'
                            //关闭弹窗，打开新的团队文件
                            this.$emit("dissolveTeamOk",res.data.data)
                        }else{
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "退出协作失败"
                            this.$store.state.snackbarType = 'error'
                        }
                    })
            },
            //关闭提示弹窗
            closeTipsDialog(){
                this.tipsDialogShow = false
                this.tipsType = ''
                this.tempId = ''
            },
            //弹窗确认
            confirmTips(){
                if(this.tipsType ==='移交'){
                    //移交处理
                    this.handoverTeamNet()
                }else if(this.tipsType ==='退出'){
                    //移交处理
                    this.exitTeamNet()
                }else if(this.tipsType ==='移除'){
                    //移交处理
                    this.removeMemberNet()
                }else if(this.tipsType ==='解散'){
                    this.dissolveTeamNet()
                }

            },
            //更改权限
            changeReadonly(){
                let data = new FormData()
                data.append('teamId',this.$store.state.currFolderId)
                data.append('teamReadonly',this.teamFileSelect)
                this.$axios.post('/authorApi/z-geo-file/setTeamReadonly',data)
                    .then((res)=>{
                        if(res.data.status === 200){
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "权限修改成功 "
                            this.$store.state.snackbarType = 'success'
                            this.$store.state.currFolderTeamReadonly = this.teamFileSelect
                        }else{
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "权限修改失败 "
                            this.$store.state.snackbarType = 'error'
                            //恢复原有选择
                            this.teamFileSelect = this.teamFileSelect === 0 ? 1:0
                        }
                    })
            },
            changeExport(){
                let data = new FormData()
                data.append('teamId',this.$store.state.currFolderId)
                data.append('teamExport',this.allowMembersExportFiles ? 1:0)
                this.$axios.post('/authorApi/z-geo-file/setTeamExport',data)
                    .then((res)=>{
                        if(res.data.status === 200){
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "权限修改成功 "
                            this.$store.state.snackbarType = 'success'
                            this.$store.state.currFolderTeamExport = this.allowMembersExportFiles ? 1:0
                        }else {
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "权限修改失败 "
                            this.$store.state.snackbarType = 'error'
                            this.allowMembersExportFiles = !this.allowMembersExportFiles
                        }
                })
            },
            changeSave(){
                let data = new FormData()
                data.append('teamId',this.$store.state.currFolderId)
                data.append('teamSave',this.allowMembersSaveFiles ? 1:0)
                this.$axios.post('/authorApi/z-geo-file/setTeamSave',data)
                    .then((res)=>{
                        if(res.data.status === 200){
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "权限修改成功 "
                            this.$store.state.snackbarType = 'success'
                            this.$store.state.currFolderTeamSave = this.allowMembersSaveFiles ? 1:0
                        }else {
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "权限修改失败 "
                            this.$store.state.snackbarType = 'error'
                            this.allowMembersSaveFiles = !this.allowMembersSaveFiles
                        }
                    })
            },
            changeInvite(){
                let data = new FormData()
                data.append('teamId',this.$store.state.currFolderId)
                data.append('teamInvite',this.allowMembersInviteOthers ? 1:0)
                this.$axios.post('/authorApi/z-geo-file/setTeamInvite',data)
                    .then((res)=>{
                        if(res.data.status === 200){
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "权限修改成功 "
                            this.$store.state.snackbarType = 'success'
                            this.$store.state.currFolderTeamInvite = this.allowMembersInviteOthers ? 1:0
                        }else {
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "权限修改失败 "
                            this.$store.state.snackbarType = 'error'
                            this.allowMembersInviteOthers = !this.allowMembersInviteOthers
                        }
                    })
            }
        },
        mounted() {
            window.addEventListener('mousedown',this.handleOnMouseDown)
            this.getMemberList()
        },
        destroyed() {
            window.removeEventListener('mousedown', this.handleOnMouseDown)
        }
    }
</script>

<style scoped>

    /*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
    ::-webkit-scrollbar {
        width: 5px; /*对垂直滚动条有效*/
        height: 5px;  /*对水平滚动条有效*/
    }
    /*定义滚动条的轨道颜色、内阴影及圆角*/
    ::-webkit-scrollbar-track {
        background-color: #FFFFFF;
    }
    /*定义滑块颜色、内阴影及圆角*/
    ::-webkit-scrollbar-thumb {
        background-color: rgba(166, 166, 166, 1);
        border-radius:2px
    }
</style>
